<template>
  <no-ssr>
    <SfCarousel
      v-if="carouselProducts.length"
      class="m-product-carousel"
      :settings="{
        type: 'slider',
        animationDuration: 250,
        rewindDuration: 500,
        rewind: true,
        perView: 4,
        peek: {
          before: 0,
          after: 50,
        },
        slidePerPage: false,
        breakpoints: {
          767: {
            perView: 1,
          },
          991: {
            perView: 2,
          },
          1200: {
            perView: 3,
          },
        }
      }"
    >
      <SfCarouselItem v-for="(product, i) in carouselProducts" :key="i">
        <SfProductCard
          :sku="product.sku"
          :title="product.title"
          :description="product.description"
          :image="product.image"
          :min-price="product.price.min"
          :regular-price="product.price.regular"
          :special-price="product.price.special"
          :base-price="product.base_price"
          :selling-unit="product.selling_unit"
          :max-rating="product.rating.max"
          :score-rating="product.rating.score"
          :link="product.link"
          :badges="product.badges"
          :bundle-options="product.bundle_options"
          :stock="product.stock"
          :wishlist-icon="false"
          :reviews="product.reviews"
          link-tag="router-link"
        />
      </SfCarouselItem>
    </SfCarousel>
  </no-ssr>
</template>
<script>
import { SfCarousel } from '@storefront-ui/vue';
import NoSSR from 'vue-no-ssr';
import { htmlDecode } from '@vue-storefront/core/filters';
import config from 'config';
import { currentStoreView } from '@vue-storefront/core/lib/multistore';
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers';
import { productThumbnailPath } from '@vue-storefront/core/helpers';
import { prepareCategoryProduct } from 'theme/helpers';
import SfProductCard from 'theme/components/organisms/o-product-card';

export default {
  name: 'MProductCarousel',
  components: {
    'no-ssr': NoSSR,
    SfCarousel,
    SfProductCard
  },
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    carouselProducts () {
      return this.products.map(prepareCategoryProduct);
    }
  }
};
</script>
